import { createAction } from '@lifesize/typescript-react-redux-utils';
import ActionTypes from 'constants/ActionTypes';

const actions = {
  onAuthenticationEdit: () => createAction(ActionTypes.AuthenticationEdit),
  onSubmitPresenterCode: (linkingCode: string) => createAction(ActionTypes.SubmitPresenterCode, { linkingCode }),
  showPresentationSelector: () => createAction(ActionTypes.ShowPresentationSelector),
  stopPresenting: () => createAction(ActionTypes.StopPresenting)
};

export default actions;



// WEBPACK FOOTER //
// ./src/actions/home.ts